<div class="tab-container mt-4">
  <div class="w-full">
    <h3 class="app text-left">Agency Name & Location</h3>
  </div>





  <form [formGroup]="agencyForm">
    <div class="w-full">
      <div class="w-full">
        <lib-form-text
          label="Agency Name"
          formControlName="agencyName">
        </lib-form-text>
      </div>
    </div>
    <div class="w-full flex gap-[35px]">
      <div class="w-full lg:w-1/2">
        <lib-form-text
          label="Primary Agency Address"
          formControlName="streetAddress">
        </lib-form-text>
      </div>
      <div class="w-full lg:w-1/2">
        <lib-form-text
          label="Suite"
          formControlName="suite">
        </lib-form-text>
      </div>
    </div>
    <div class="w-full flex gap-[35px]">
      <div class="w-full lg:w-1/2">
        <lib-form-text
          label="City"
          formControlName="city">
        </lib-form-text>
      </div>
      <div class="w-full lg:w-1/2">
        <div class="w-full flex gap-[35px]">
          <div class="w-full lg:w-1/2">
            <lib-form-dropdown
              label="State"
              formControlName="state"
              [options]="states()">
            </lib-form-dropdown>
          </div>
          <div class="w-full lg:w-1/2">
            <lib-form-text
              label="Zip Code"
              formControlName="zipCode"
              mask="99999">
            </lib-form-text>
          </div>
        </div>
      </div>
    </div>
    <div class="w-full flex gap-[35px]">
      <div class="w-full lg:w-1/2">
        <lib-form-text
          label="Agency License #"
          formControlName="licenseNumber">
        </lib-form-text>
      </div>
      <!-- <div class="w-full lg:w-1/2">
      <lib-form-text
        label="Agency Email Address"
        formControlName="agencyEmail">
      </lib-form-text>
    </div> -->
    <div class="w-full lg:w-1/2">
      <lib-form-text
        label="Agency Website"
        formControlName="websiteUrl">
      </lib-form-text>
    </div>
  </div>
  <div class="w-full flex gap-[35px]">
    <div class="w-full lg:w-1/2">
      <lib-form-phone
        label="Agency Phone"
        formControlName="phone">
      </lib-form-phone>
    </div>
  </div>

  <div class="w-full mt-[40px]">
    <h3 class="app text-left">Programs</h3>
  </div>

  <div  class="form-field-container">
    <div formArrayName="checkboxes">
      @for (control of checkboxesFormArray.controls; track control; let i = $index) {
        <div class="form-field">
          <mat-checkbox [formControlName]="i">
            {{ programs()[i].name }}
          </mat-checkbox>
        </div>
      }
    </div>
  </div>
</form>
</div>
